import { createSlice } from '@reduxjs/toolkit'

export const resvarSlice = createSlice({
    name: 'resvar',
    initialState: {
        value: []
    },
    reducers: {
        resvarAction: (state, action) => {
            state.value = action.payload
        },
    },
})

export const { resvarAction } = resvarSlice.actions

export default resvarSlice.reducer